module.exports = __webpack_public_path__ + "static/media/nytimes.com_interactive_2016_us_elections_polls.html_plot.3aded123.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_interactive_2016_us_elections_polls.html_plot.png
// module id = 413
// module chunks = 0